import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeftBig24, IcoClose24 } from '@onefootprint/icons';
import { IconButton, useConfirmationDialog } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { LEGACY_IDV_CONTAINER_ID, TOUCH_TARGET_CLASS } from '@/idv2/components/constants';
import { useNavigationHeaderPortalId } from '@/idv2/components/internal/gallery-portal-context';
import { useDynamicTitle } from './hooks/use-dynamic-title';
export type NavigationHeaderProps = {
  canGoBack: boolean;
  onBack: () => void;
  onClose?: () => void;
  containerId?: string;
  hideButtons?: boolean;
};
export const NavigationHeader = t0 => {
  const $ = _c(28);
  const {
    canGoBack,
    onBack,
    onClose,
    containerId: t1,
    hideButtons: t2
  } = t0;
  const containerId = t1 === undefined ? LEGACY_IDV_CONTAINER_ID : t1;
  const hideButtons = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      keyPrefix: "confirmationDialog"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t3);
  const headerRef = useRef(null);
  const [portalTarget, setPortalTarget] = useState(null);
  let t4;
  if ($[1] !== containerId) {
    t4 = {
      containerId,
      headerRef
    };
    $[1] = containerId;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const dynamicTitle = useDynamicTitle(t4);
  const confirmationDialog = useConfirmationDialog();
  const hasContent = dynamicTitle || !hideButtons;
  const portalId = useNavigationHeaderPortalId();
  let t5;
  let t6;
  if ($[3] !== portalId) {
    t5 = () => {
      setPortalTarget(document.getElementById(portalId));
    };
    t6 = [portalId];
    $[3] = portalId;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  useLayoutEffect(t5, t6);
  let t7;
  if ($[6] !== confirmationDialog || $[7] !== onClose || $[8] !== t) {
    t7 = () => {
      confirmationDialog.open({
        title: t(_temp),
        description: t(_temp2),
        primaryButton: {
          label: t(_temp3),
          onClick: onClose
        },
        secondaryButton: {
          label: t(_temp4)
        }
      });
    };
    $[6] = confirmationDialog;
    $[7] = onClose;
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleClose = t7;
  if (!portalTarget) {
    return null;
  }
  const t8 = dynamicTitle || !hideButtons || undefined;
  const t9 = !hasContent;
  let t10;
  if ($[10] !== hasContent || $[11] !== t9) {
    t10 = cx("navigation-header flex items-center justify-center relative z-1", {
      "h-12 py-3 min-[900px]:h-14 min-[900px]:py-4": hasContent,
      "py-2": t9
    });
    $[10] = hasContent;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== canGoBack || $[14] !== handleClose || $[15] !== hideButtons || $[16] !== onBack) {
    t11 = !hideButtons && <div className="absolute left-0">{canGoBack ? <IconButton className={TOUCH_TARGET_CLASS} onClick={onBack} aria-label="Go back" icon={IcoChevronLeftBig24} /> : <IconButton className={TOUCH_TARGET_CLASS} onClick={handleClose} aria-label="Close" icon={IcoClose24} />}</div>;
    $[13] = canGoBack;
    $[14] = handleClose;
    $[15] = hideButtons;
    $[16] = onBack;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== dynamicTitle) {
    t12 = dynamicTitle && <span className="text-label-2 text-primary text-center whitespace-nowrap overflow-hidden text-ellipsis max-w-[calc(100%-80px)]">{dynamicTitle}</span>;
    $[18] = dynamicTitle;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t8) {
    t13 = <div ref={headerRef} data-has-content={t8} className={t10}>{t11}{t12}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== portalTarget || $[26] !== t13) {
    t14 = createPortal(t13, portalTarget);
    $[25] = portalTarget;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3($_1) {
  return $_1.confirm;
}
function _temp4($_2) {
  return $_2.cancel;
}